var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"webOnlyNotice"},[_c('title-component',{attrs:{"title":_vm.$t('payments.webOnly.title'),"type":"h2"}}),_c('div',{staticClass:"mt-3 webOnlyMessage"},[_vm._v(_vm._s(_vm.$t('payments.webOnly.message')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }